import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import Layout from "../../layout";
import { Col, Form, Row } from "react-bootstrap";
import { useDownloadExcel } from "react-export-table-to-excel";
import Services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import ReactDatePicker from "react-datepicker";
import ReactGA from "react-ga4";
import { mainUrl } from "API/client/api";
import { toast } from "react-toastify";
import axios from "axios";

const PropertyReport = () => {
    const { register, handleSubmit, watch, setValue } = useForm();
    const { userDetail } = useSelector(authenticationSeletor);
    const { access_token } = useSelector((state) => state.authentication);

    const [fromdate, setFromDate] = useState(null);
    const [todate, setToDate] = useState(null);
    const [fadeKey, setFadeKey] = useState(0);

    const { zone, state, hub, city, locality, initiator } = watch();

    const [zones, setZones] = useState([]);
    const [states, setStates] = useState([]);
    const [hubs, setHubs] = useState([]);
    const [cities, setCities] = useState([]);
    const [localities, setLocalities] = useState([]);
    const [initiators, setInitiators] = useState([]);
    const [status, setStatus] = useState("");
    const [hourly, setHourly] = useState(false);
    const [prepaid, setPrepaid] = useState(false);

    console.log({ zone, state, hub, city, locality, initiator, fromdate, todate, status, hourly, prepaid });

    const tableRef = useRef();
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: "propertyDetails",
        sheet: "Property Details",
    });

    // ----- Fetch Zones -----
    const fetchZones = async () => {
        try {
            const res = await Services.property.allZoneService();
            if (res.data.status) setZones(res.data.data);
        } catch (error) {
            console.log("Error fetching zones:", error);
        }
    };

    useEffect(() => { fetchZones(); }, []);

    // ----- Fetch States by Zone -----
    const fetchStateByZone = async (zoneId) => {
        try {
            const res = await Services.property.getStateByZone(zoneId);
            if (res.data.status) setStates(res.data.data);
        } catch (error) {
            console.log("Error fetching states:", error);
        }
    };

    useEffect(() => { if (zone) fetchStateByZone(zone); }, [zone]);

    // ----- Fetch Hubs by State -----
    const fetchHubByState = async (stateId) => {
        try {
            const res = await Services.property.getHubByState(stateId);
            if (res.data.status) setHubs(res.data.data.Hubs || []);
        } catch (error) {
            console.log("Error fetching hubs:", error);
        }
    };

    useEffect(() => { if (state) fetchHubByState(state); }, [state]);

    // ----- Fetch Cities by Hub -----
    const fetchCityByHub = async (hubId) => {
        try {
            const res = await Services.property.getCityByHub(hubId);
            if (res.data.status) setCities(res.data.data || []);
        } catch (error) {
            console.log("Error fetching cities:", error);
        }
    };

    useEffect(() => { if (hub) fetchCityByHub(hub); }, [hub]);

    // ----- Fetch Localities by City -----
    const fetchLocalitiesByCity = async (cityId) => {
        try {
            if (!cityId) return setLocalities([]);
            const res = await axios.get(`${mainUrl}api/country/locality-city/${cityId}`, {
                headers: { Authorization: `Bearer ${access_token}` },
            });
            if (res.data.status) setLocalities(res.data.data || []);
        } catch (error) {
            console.log("Error fetching localities:", error);
        }
    };

    useEffect(() => { if (city) fetchLocalitiesByCity(city); }, [city]);

    // ----- Fetch Initiator -----
    const fetchInitiators = async () => {
        try {
            const res = await axios.get(
                `${mainUrl}api/auth/rrooms-users/role/10`,
                {
                    headers: {
                        Authorization: `Bearer ${access_token}`,
                    },
                }
            );
            if (res.data.status) {
                setInitiators(res.data.data || []);
            }
        } catch (error) {
            console.log("Error fetching initiators:", error);
        }
    };

    useEffect(() => { fetchInitiators(); }, []);

    useEffect(() => { ReactGA.send({ hitType: "pageview", page: "property_reporting" }); }, [userDetail]);

    const PropertyStatus = {
        0: "Pending",
        1: "Live",
        2: "Sold Out",
        3: "Block"
    }

    useEffect(() => { setFadeKey((prev) => prev + 1); }, [status]);

    // ----- Submit Filter & Download Excel -----
    const submitFilter = async () => {
        try {
            const params = new URLSearchParams();
            if (fromdate) params.append("fromDate", fromdate.toISOString().split("T")[0]);
            if (todate) params.append("toDate", todate.toISOString().split("T")[0]);
            if (status != "" && status != null && status != undefined) { params.append("status", status); }
            if (hub) params.append("hub", hub);
            if (state) params.append("stateId", state);
            if (city) params.append("cityId", city);
            if (locality) params.append("locality", locality);
            if (initiator) params.append("createdBy", initiator);
            if (hourly) params.append("hourly", 1);
            if (prepaid) params.append("prepaid", 1);
            const res = await axios.get(
                `${mainUrl}api/rrooms-property/property-report-download?${params.toString()}`,
                {
                    responseType: "blob",
                    headers: { Authorization: `Bearer ${access_token}` },
                }
            );
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Property_Report.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success("Property report downloaded successfully!");
        } catch (error) {
            console.log("Error downloading report:");
        }
    };

    return (
        <Layout title="Property Report">
            <div className="tab-primary border-bottom"><h3>Property Report</h3></div>
            <div className="flex justify-content-center align-items-center report-page">
                <div className="flex col-lg-12 d-flex justify-content-center p-0">
                    <Form className="bg-white rounded-2 report-form" onSubmit={handleSubmit(submitFilter)}>
                        <Row key={fadeKey} className="addBookingRow fade-in-box g-3">
                            <Col lg={2} className="form-group">
                                <label className="text-black">Zone</label>
                                <select className="form-control" {...register("zone")}>
                                    <option value="">Select Zone</option>
                                    {zones?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">State</label>
                                <select className="form-control" {...register("state")}>
                                    <option value="">Select State</option>
                                    {states?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">Hub</label>
                                <select className="form-control" {...register("hub")}>
                                    <option value="">Select Hub</option>
                                    {hubs?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.hubname}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">City</label>
                                <select className="form-control" {...register("city")}>
                                    <option value="">Select City</option>
                                    {cities?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">Locality</label>
                                <select className="form-control" {...register("locality")}>
                                    <option value="">Select Locality</option>
                                    {localities?.map((item) => (
                                        <option key={item.id} value={item.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">Initiator</label>
                                <select className="form-control" {...register("initiator")}>
                                    <option value="">Select Initiator</option>
                                    {initiators?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.firstName + ' ' + item.lastName} ({item.userCode})
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black">Status</label>
                                <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value="">All Status</option>
                                    {Object.entries(PropertyStatus).map(([key, label]) => (
                                        <option key={key} value={key}>{label}</option>
                                    ))}
                                </select>
                            </Col>
                            <Col lg={4} className="form-group gap-2 d-flex flex-column">
                                <label className="text-black m-0 fs-6">Date Range</label>
                                <ReactDatePicker
                                    selectsRange={true}
                                    startDate={fromdate}
                                    endDate={todate}
                                    onChange={(dates) => {
                                        const [start, end] = dates;
                                        setFromDate(start);
                                        setToDate(end);
                                    }}
                                    className="field-control"
                                    dateFormat="yyyy/MM/dd"
                                    placeholderText="Select date range"
                                />
                            </Col>
                            <Col lg={2} className="form-group">
                                <label className="text-black d-block mb-2">Property Allow</label>
                                <div className="d-flex gap-3 align-items-center justify-content-between py-2">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="hourly"
                                            checked={hourly}
                                            onChange={(e) => setHourly(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="hourly">Hourly</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="prepaid"
                                            checked={prepaid}
                                            onChange={(e) => setPrepaid(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="prepaid">Prepaid</label>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} className="text-right pt-3">
                                <button type="submit" className="btn btn-success rounded-5">
                                    Export Report
                                </button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </Layout>
    );
};

export default PropertyReport;
